module.exports = __webpack_public_path__ + "img/confirm-yes.ea4c93d1.png";